import { runtimeConfig } from "./runtime-config";

const RUNTIME_CONFIG = runtimeConfig();

/** Public launch controls. Keep unfinished programmes out of navigation and direct routes. */
export const STAKING_ENABLED = RUNTIME_CONFIG.stakingEnabled;
